module.exports = __webpack_public_path__ + "img/default-provider-logo.5fb12679.svg";